import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onSetAlert"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';
import uploadFile from 'utils/file/uploadFile';
import { errorCodesToTranslationKeys } from 'utils/i18n';
function useUploadFile(_ref) {
  var onSetAlert = _ref.onSetAlert,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  function uploadFileWithProgress(_x) {
    return _uploadFileWithProgress.apply(this, arguments);
  }
  function _uploadFileWithProgress() {
    _uploadFileWithProgress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var file, referenceId, referenceIds, type, language, skipPostProcessing, skipAssigningToReference, notifyOnProcessingCompletion, style, alternativeText;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            file = _ref2.file, referenceId = _ref2.referenceId, referenceIds = _ref2.referenceIds, type = _ref2.type, language = _ref2.language, skipPostProcessing = _ref2.skipPostProcessing, skipAssigningToReference = _ref2.skipAssigningToReference, notifyOnProcessingCompletion = _ref2.notifyOnProcessingCompletion, style = _ref2.style, alternativeText = _ref2.alternativeText;
            return _context.abrupt("return", uploadFile({
              file: file,
              referenceId: referenceId,
              referenceIds: referenceIds,
              type: type,
              language: language,
              skipPostProcessing: skipPostProcessing,
              skipAssigningToReference: skipAssigningToReference,
              notifyOnProcessingCompletion: notifyOnProcessingCompletion,
              style: style,
              alternativeText: alternativeText,
              onProgress: function onProgress(progress) {
                onSetAlert({
                  message: file.name,
                  suppressTimeout: true,
                  type: 'success',
                  progress: progress
                });
              }
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _uploadFileWithProgress.apply(this, arguments);
  }
  var _useMutation = useMutation(uploadFileWithProgress, _objectSpread({
      onMutate: function onMutate(_ref3) {
        var file = _ref3.file;
        onSetAlert({
          title: file.name,
          suppressTimeout: true,
          type: 'success'
        });
      },
      onSuccess: function onSuccess(data, _ref4) {
        var file = _ref4.file;
        onSetAlert({
          type: 'success',
          title: i18n.t('alert_file_uploaded_success', {
            name: file.name
          }),
          progress: 100,
          suppressTimeout: false
        });
      },
      onError: function onError(error, _ref5) {
        var _error$response, _error$response$data, _error$response2, _error$response2$data;
        var file = _ref5.file;
        var errorTranslationKey = errorCodesToTranslationKeys[((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.code) || error.code];
        var message = errorTranslationKey ? t(errorTranslationKey) : ((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message) || error.formattedErrorMessage || error.message;
        onSetAlert({
          type: 'fail',
          title: i18n.t('alert_file_uploaded_error', {
            name: file.name
          }),
          message: message,
          suppressTimeout: true
        });
      }
    }, options)),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    uploadFile: mutateAsync
  });
}
export default useUploadFile;